import { GetOrCreateVideoControllerParameters } from "../VideoControllerFactory"
import { useVideoControllerMultipleFlightEventBinding } from "./useEventBinding"

export function useMultipleVideoData({
    flightIds,
    options,
}: {
    flightIds: string[]
    options?: GetOrCreateVideoControllerParameters["options"]
}) {
    return useVideoControllerMultipleFlightEventBinding({
        flightIds,
        options,
        func: (controller) => controller.getData(),
        events: ["dataChanged"],
    })
}

export function useMultipleCurrentFrameIndex({
    flightIds,
    options,
}: {
    flightIds: string[]
    options?: GetOrCreateVideoControllerParameters["options"]
}) {
    return useVideoControllerMultipleFlightEventBinding({
        flightIds,
        options,
        func: (controller) => controller.getCurrentFrameNumber(),
        events: ["dataChanged", "videoProgressChanged"],
    })
}

export function useMultipleHasPlayedVideo({
    flightIds,
    options,
}: {
    flightIds: string[]
    options?: GetOrCreateVideoControllerParameters["options"]
}) {
    return useVideoControllerMultipleFlightEventBinding({
        flightIds,
        options,
        func: (controller) => controller.hasPlayedVideo(),
        events: ["isPlayingChanged"],
    })
}
